import Immutable from 'immutable';

import * as dateTime from 'globals/datetime';
import { loadCookie, saveCookie, removeCookie } from 'globals/cookieHelper';
import AppAPI from '../../../../api/';

import {
  getCompany,
  getCompanyHistorySetting,
  getLastSeenTimeInSessionID,
  getSingleChatId,
  getLastActivity,
  getIsCampaignClicked,
} from './selectors';
import * as actions from './actions';

export const CHAT_ROUTE_TO_FORM = 'chat-route-to-form';
export const CHAT_ROUTE_TO_CONVERSATION = 'chat-route-to-conversation';
export const CHAT_ROUTE_TO_HISTORY = 'chat-route-to-history';

export const chatRouteToConversation = sessionId => {
  saveCookie('chat-route', 'conversation');
  saveCookie('sessionId', sessionId);
  return { type: CHAT_ROUTE_TO_CONVERSATION, sessionId };
};

export const chatRouteToForm = id => {
  saveCookie('chat-route', 'form');
  saveCookie('formId', id);
  return { type: CHAT_ROUTE_TO_FORM };
};

export const chatRouteToHistory = () => {
  saveCookie('chat-route', 'history');
  removeCookie('sessionId');
  return { type: CHAT_ROUTE_TO_HISTORY };
};

export const handleJoinConversation = session => {
  return dispatch => {
    const sessionId = session.get('id');
    dispatch(actions.handleMarkChatSessionSeen(sessionId));
    dispatch(chatRouteToConversation(sessionId));
  };
};

export const handleJoinConversationById = sessionId => {
  return dispatch => {
    return AppAPI.getChatSession(sessionId)
      .then(session => {
        return dispatch(handleJoinConversation(Immutable.fromJS(session)));
      })
      .catch(() => {
        removeCookie('sessionId');
        return dispatch(handleCreateNewConversation()); // eslint-disable-line no-use-before-define
      });
  };
};

export const handleCreateNewConversation = formPrefill => {
  return async (dispatch, getState) => {
    const state = getState();
    const company = getCompany(state);
    const singleSessionChat = company.get('singleSessionChat');

    if (!formPrefill) {
      AppAPI.removeTempFormOverride();
    }

    const activeForm = AppAPI.getTempFormOverride() || AppAPI.getFormOverride() || company.activeForm;

    if (singleSessionChat) {
      const activeSessionId = getSingleChatId(state);
      if (activeSessionId) return dispatch(chatRouteToConversation(activeSessionId));
    }

    if (!activeForm) {
      return dispatch(chatRouteToConversation('new'));
    }

    try {
      const form = await dispatch(actions.fetchFormById(activeForm, formPrefill));
      const formHasQuestions = form.questions && form.questions.length;

      if (formHasQuestions) {
        return dispatch(chatRouteToForm(form.id));
      }

      return dispatch(chatRouteToConversation('new'));
    } catch (e) {
      throw e;
    }
  };
};

export const handleRouteToHistory = () => {
  return (dispatch, getState) => {
    const showHistory = getCompanyHistorySetting(getState());
    if (!showHistory) {
      // eslint-disable-next-line no-use-before-define
      dispatch(handleRouteToConversation());
      return;
    }
    dispatch(chatRouteToHistory());
  };
};

export const handleRouteToConversation = () => {
  return (dispatch, getState) => {
    const sessionId = loadCookie('sessionId');

    if (!sessionId || sessionId === 'new') {
      dispatch(handleCreateNewConversation());
    } else {
      const showHistory = getCompanyHistorySetting(getState());
      const sessionLastSeenAt = getLastSeenTimeInSessionID(getState(), sessionId);
      const isSessionExpired = Date.now() - sessionLastSeenAt > dateTime.ONE_DAY;

      if (isSessionExpired && showHistory) {
        dispatch(handleRouteToHistory());
      } else {
        dispatch(handleJoinConversationById(sessionId));
      }
    }
  };
};

const dispatchNewChatRoute = (dispatch, store) => {
  const sessions = store.getIn(['chat', 'sessions']);
  if (sessions && sessions.size > 0) {
    dispatch(handleRouteToHistory());
  } else {
    dispatch(handleRouteToConversation());
  }
};

const dispatchSavedChatRoute = dispatch => {
  const savedRoute = loadCookie('chat-route');
  if (savedRoute === 'conversation') {
    dispatch(handleRouteToConversation());
    return true;
  } else if (savedRoute === 'history') {
    dispatch(handleRouteToHistory());
    return true;
  }

  return false;
};

export const updateCookiesForCustomerId = () => {
  const appCustomerId = AppAPI.customerId;
  const cookieCustomerId = loadCookie('cust-id');
  if (appCustomerId !== cookieCustomerId) {
    removeCookie('chat-route');
    removeCookie('sessionId');
    removeCookie('d-em');
  }

  saveCookie('cust-id', appCustomerId);
};

export const handleFirstChatRoute = () => {
  return (dispatch, getStore) => {
    const localActivity = getLastActivity(getStore());
    dispatch(actions.handleStartConnection(localActivity, true));
    updateCookiesForCustomerId();
    const campaignClicked = getIsCampaignClicked(getStore());

    if (campaignClicked) {
      dispatch(actions.toggleCampaignClicked(false));
      return;
    }

    if (!dispatchSavedChatRoute(dispatch)) {
      dispatchNewChatRoute(dispatch, getStore());
    }
  };
};
